// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customUnhandledModalErrorMessageStyles } from "@guestsupply/App/Widgets/Common/CustomUnhandledModalErrorMessageContent";
import { css } from "styled-components";

customUnhandledModalErrorMessageStyles.errorDetailsTitle = {
    as: "h2",
    weight: 700,
    css: css`
        margin-bottom: 5px;
        margin-top: 10px;
        font-size: 14px;
        line-height: 19px;
    `,
};
customUnhandledModalErrorMessageStyles.customerServiceEmail = {
    typographyProps: {
        css: css`
            font-size: 16px;
        `,
    },
};
